import api from '../../../services/Api';
import { IAuditoriaLancamentoCorretivoResultado } from '../interfaces/IAuditoriaLancamentoCorretivo';

export const AuditoriaLancamentoCorretivoService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaLancamentoCorretivoResultado> {
    const response = await api.get<IAuditoriaLancamentoCorretivoResultado>('auditoria-lancamento-corretivo/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        orientacaoJustificativa: '',
        lancamentosCorretivos: [],
      }
    );
  },
};
